var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg092Money(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 255,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,284c11.046,0,20-8.954,20-20V148c0-44.112-35.888-80-80-80H80c-44.112,0-80,35.888-80,80v216 c0,44.112,35.888,80,80,80h352c44.112,0,80-35.888,80-80c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20 c0,22.056-17.944,40-40,40H80c-22.056,0-40-17.944-40-40V148c0-22.056,17.944-40,40-40h352c22.056,0,40,17.944,40,40v116 C472,275.046,480.954,284,492,284z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,255.878c0,59.552,45.309,108,101,108c55.691,0,101-48.448,101-108s-45.309-108-101-108 C200.309,147.878,155,196.326,155,255.878z M317,255.878c0,37.495-27.364,68-61,68s-61-30.505-61-68s27.364-68,61-68 S317,218.383,317,255.878z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 255,
    r: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg092Money);
export default __webpack_public_path__ + "static/media/092-money.43b617ecb742675d27ffc0ed535d8fdb.svg";
export { ForwardRef as ReactComponent };